function toggleSubmenu(toggle, expanded) {
	toggle.setAttribute('aria-expanded', expanded);
	const submenu = toggle.parentElement.nextElementSibling;
	if (submenu) {
		submenu.classList.toggle('hidden', !expanded);
	}
}

const mobileBreakpoint = 1120;

document.addEventListener('DOMContentLoaded', function () {
	const toggles = document.querySelectorAll('.submenu-toggle');
	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			console.log('click', toggle, toggle.getAttribute('aria-expanded'));
			toggleSubmenu(
				toggle,
				!(toggle.getAttribute('aria-expanded') === 'true')
			);
		});
		toggle
			.closest('.menu-item-has-children')
			.addEventListener('mouseenter', () => {
				if (window.innerWidth >= mobileBreakpoint) {
					toggleSubmenu(toggle, true);
				}
			});
		toggle
			.closest('.menu-item-has-children')
			.addEventListener('mouseleave', () => {
				if (window.innerWidth >= mobileBreakpoint) {
					toggleSubmenu(toggle, false);
				}
			});
	});
});

function throttle(func, limit = 50) {
	let inThrottle;
	return function (...args) {
		if (!inThrottle) {
			func.apply(this, args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}

document.addEventListener('DOMContentLoaded', function () {
	const headerMenuButton = document.getElementById('header-burger-menu');
	const headerMenuContent = document.getElementById('header-menu');

	function updateMenuState(windowWidth) {
		if (windowWidth >= mobileBreakpoint) {
			headerMenuContent.classList.remove('hidden');
			headerMenuButton.setAttribute('aria-expanded', 'true');
			headerMenuButton.classList.add('hidden');
		} else {
			headerMenuContent.classList.add('hidden');
			headerMenuButton.setAttribute('aria-expanded', 'false');
			headerMenuButton.classList.remove('hidden');
		}
	}

	// Toggle menu on button click
	headerMenuButton.addEventListener('click', () => {
		const isExpanded =
			headerMenuButton.getAttribute('aria-expanded') === 'true';
		headerMenuButton.setAttribute('aria-expanded', !isExpanded);
		headerMenuContent.classList.toggle('hidden');
	});

	window.addEventListener(
		'resize',
		throttle(() => {
			updateMenuState(window.innerWidth);
		}, 50)
	);

	// Initial check on page load
	updateMenuState(window.innerWidth);
});
